import { getAnswers, getInspectionsList } from "../../services/answerService";
import {
    setData,
    setError,
    setFilteredAnswers,
    setInspections,
    setLoading,
    setLoadingInspections,
    setErrorInspections,
} from "../slices/answerSlice";
import { AppThunk } from "../store";

export const fetchAnswers = (inspectionId: string): AppThunk => async (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(false));

    try {
        const response = await getAnswers(inspectionId);

        if (response) {
            dispatch(setData(response));
            dispatch(setFilteredAnswers(response));
        } else {
            throw Error('no data');
        }
    } catch (e) {
        console.error(e);
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
};

export const fetchInspectionsList = (): AppThunk => async (dispatch) => {
    dispatch(setLoadingInspections(true));
    dispatch(setErrorInspections(false));

    try {
        const response = await getInspectionsList();

        if (response) {
            dispatch(setInspections(response));
        } else {
            throw Error('no data');
        }
    } catch (e) {
        console.error(e);
        dispatch(setErrorInspections(true));
    } finally {
        dispatch(setLoadingInspections(false));
    }
};
